import React, {FC} from "react";
import {useField} from "formik";
import {TextField, TextFieldProps} from "@material-ui/core";
import NumberFormat from "react-number-format";

interface FormikTextFieldProps {
    name: string;
    label?: string;
    suffix?: string;
    currency?: boolean;
    withoutTouched?: boolean; // hack
}

interface NumberFormatCustomProps {
    inputRef: (instance: NumberFormat | null) => void;
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
    suffix?: string;
    currency?: boolean;
}

function NumberFormatCustom(props: NumberFormatCustomProps) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            suffix={props.suffix}
            decimalScale={props.currency ? 2 : undefined}
            fixedDecimalScale={props.currency}
            thousandSeparator
            isNumericString
        />
    );
}

export const FormikTextField: FC<FormikTextFieldProps & Omit<TextFieldProps, 'name'>> = (props) => {
    const [, meta, helpers] = useField<string | number>(props.name);
    const {type, suffix, currency, ...restProps} = props
    return (
        type === 'number'
            ? (
                <TextField
                    {...restProps}
                    value={meta.value}
                    error={meta.touched && Boolean(meta.error)}
                    helperText={meta.touched && meta.error}
                    onChange={(e) =>
                        helpers.setValue(parseFloat(e.target.value))
                    }
                    InputProps={{
                        inputComponent: NumberFormatCustom as any,
                    }}
                />
            )
            : (
                <TextField
                    {...restProps}
                    type={type === 'number' ? undefined : type}
                    value={meta.value || ''}
                    onChange={(e) =>
                        type === 'number'
                            ? helpers.setValue(parseFloat(e.target.value))
                            : helpers.setValue(e.target.value)
                    }
                    error={(props.withoutTouched || meta.touched) && Boolean(meta.error)}
                    helperText={(props.withoutTouched || meta.touched) && meta.error}
                />
            )
    )
}
